<template>
  <div class="terms-page">
    <PageTitle
      title="Terms of Service"
      subtitle="A breakdown of what it means to use CrowdFlik For Developers, and what we expect from you."
      backgroundClass="-banner is-dark -banner-01"
    />
    <section class="section">
      <div class="container">
        <div class="box">
          <TermsCopy />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import TermsCopy from "@/components/copy/TermsCopy.vue";

export default {
  name: "termsPage",
  components: {
    PageTitle,
    TermsCopy
  }
};
</script>

<style scoped lang="scss"></style>
